<template>
  <div class="main">
    <product-banner class-name="productBg" :title="banner.title" :desc="banner.desc"></product-banner>
    <div class="advantage">
      <div class="advantage-container w">
        <div class="m-title">
          <h2>产品优势</h2>
        </div>
        <ul class="advantage-nav">
          <li
            v-for="(item,index) in advantageList"
            :key="item.id"
            :class="{active:advantageNum==index}"
            @mouseover="advantageOver(index)"
          >
            <svg-icon
              :icon-class="advantageNum==index?item.svgOn:item.svg"
              class-name="advantage-svg"
            ></svg-icon>
            <p>{{item.name}}</p>
          </li>
        </ul>

        <div
          class="advantage-content"
          v-for="(item,index) in advantageList"
          :key="item.id"
          v-show="index == advantageNum"
        >
          <div class="advantage-content-left">
            <p>{{item.content}}</p>
          </div>
          <div class="advantage-content-right">
            <svg-icon :icon-class="item.path" class-name="advantage-content"></svg-icon>
          </div>
        </div>
      </div>
    </div>

    <div class="fun">
      <div class="fun-container w">
        <div class="m-title">
          <h2>产品功能</h2>
        </div>
        <div class="fun-content">
          <div class="fun-content-row" v-for="item in funList" :key="item.id">
            <div class="fun-info">
              <h3 class="fun-h3">{{item.name}}</h3>
              <div class="fun-desc">{{item.desc}}</div>
              <ul class="fun-list">
                <li>{{item.content}}</li>
              </ul>

              <to-try class-name="c-link" type="1"></to-try>
            </div>
            <div class="fun-pic">
              <svg-icon :icon-class="item.path" class-name="fun_svg"></svg-icon>
            </div>
          </div>
        </div>
      </div>
    </div>

    <to-try class-name="c-apply" type="2"></to-try>
  </div>
</template>
<script>
export default {
  data() {
    return {
      banner: {
        title: "在线教育系统",
        desc: "低成本、高效率的药房培训系统"
      },
      advantageNum: 0,
      advantageList: [
        {
          svg: "educat_advantage_svg1",
          svgOn: "educat_advantage_svgOn1",
          name: "高效学习",
          content:
            "支持多终端，突破时间和空间的限制；强针对性考题，提高了学员学习效率；多奖励机制，提高学员学习积极性。",
          path: "educat_advantage_pic1"
        },
        {
          svg: "educat_advantage_svg2",
          svgOn: "educat_advantage_svgOn2",
          name: "节省培训成本",
          content: "线上随时随地培训学习，减少人员培训成本。",
          path: "educat_advantage_pic1"
        }
      ],
      funList: [
        {
          path: "educat_fun_svg1",
          name: "线上学习与考试",
          desc: "学习、考试资料的全汇总资料",
          content: ""
        },
        {
          path: "educat_fun_svg2",
          name: "学习进度环",
          desc: "可提醒学员的学习进度，激励学员学习热情",
          content: ""
        },
        {
          path: "educat_fun_svg3",
          name: "学习与考试情况分析",
          desc:
            "多维度分析学员的学习和考试情况，让学员找到自己的弱项，进而有针对性的提高。",
          content: ""
        }
      ]
    };
  },
  methods: {
    advantageOver(index) {
      this.advantageNum = index;
    }
  }
};
</script>
<style lang='scss' scoped>
$color: #6404dc;
/deep/ .c-link {
  background: $color;
}
/deep/ .c-apply {
  color: $color;
  background: $color;
}

/deep/ .productBg {
  background-image: url("../../assets/imgs/banner_educat.png");
}

.m-title {
  h2 {
    &::after {
      content: "";
      background: $color;
    }
  }
}
// .banner {
//   width: 100%;
//   height: 500px;
//   background: url("../../assets/imgs/banner_educat.png") no-repeat top center /
//     100% 500px;
//   overflow: hidden;
//   .banner-title {
//     font-size: 58px;
//     font-weight: bold;
//     line-height: 81px;
//     color: #fff;
//     margin: 220px auto 0;
//     text-align: center;
//   }
//   .banner-desc {
//     font-size: 24px;
//     font-weight: 300;
//     color: #fff;
//     line-height: 32px;
//     margin-top: 14px;
//     text-align: center;
//   }
// }
.advantage {
  width: 100%;
  background: #f3f5f8;
  padding: 72px 0 0;
  .advantage-nav {
    @include clearfix;
    background: #fff;
    li {
      float: left;
      width: 50%;
      height: 206px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #2f393f;
      border-bottom: 2px solid transparent;
      cursor: pointer;
      .advantage-svg {
        width: 64px;
        height: 64px;
      }
      p {
        font-size: 22px;
        font-weight: 300;
        line-height: 30px;
        text-align: center;
        margin-top: 24px;
      }
    }
    .active {
      color: $color;
      border-bottom: 2px solid $color;
    }
  }

  .advantage-content {
    height: 575px;
    @include clearfix;
    .advantage-content-left {
      float: left;
      width: 40%;
      height: 100%;
      p {
        width: 403px;
        margin: 150px 0 0 40px;
        font-size: 16px;
        font-weight: 400;
        color: #6c737d;
        line-height: 34px;
      }
    }
    .advantage-content-right {
      float: right;
      width: 600px;
      height: 100%;
      .advantage-content {
        margin-top: 96px;
        width: 600px;
        height: 360px;
      }
    }
  }
}

.fun {
  padding: 72px 0 0;
  .fun-content-row {
    padding: 0 80px 92px;
    @include clearfix;
    .fun-info {
      float: left;
      width: 434px;
      .fun-h3 {
        font-size: 24px;
        font-weight: 300;
        color: #2f393f;
        line-height: 32px;
      }
      .fun-desc {
        color: #2f393f;
        font-size: 20px;
        font-weight: 300;
        line-height: 32px;
      }
      .fun-list {
        margin-top: 16px;
        li {
          font-size: 14px;
          font-weight: 400;
          color: #6c737d;
          line-height: 25px;
          margin-bottom: 12px;
        }
      }
    }
    .fun-pic {
      float: right;
    }
    .fun_svg {
      width: 400px;
      height: 350px;
    }
    &:nth-child(1) {
      .fun_svg {
        width: 526px;
        height: 388px;
      }
      .fun-info {
        margin-top: 83px;
      }
    }
    &:nth-child(2) {
      .fun_svg {
        width: 407px;
        height: 341px;
      }
      .fun-info {
        margin-top: 76px;
      }
    }
    &:nth-child(3) {
      .fun_svg {
        width: 468px;
        height: 394px;
      }
      .fun-info {
        margin-top: 108px;
      }
    }
    &:nth-child(2n) {
      .fun-info {
        float: right;
      }
      .fun-pic {
        float: left;
      }
    }
  }
}
</style>
